import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppBar, CircularProgress, IconButton, Toolbar, Typography } from '@material-ui/core'
import { changeLoading } from '../../../../store/actions/loading.action'
import { chartPeriod, chartHourly, change } from '../../../../store/actions/campaigns.action'
import ChartPeriod from '../../../components/chart/chart-days'
import ChartHours from '../../../components/chart/chart-hours'
import { MdKeyboardBackspace } from 'react-icons/md'
import { changeScreen } from '../../../../store/actions/navigation.action'
import { chartGeneralPeriod } from '../../../../store/actions/links.action'


export default function ChartCampaign(props) {
    const dispatch = useDispatch()
    const campaign_id = (props.uid) ? props.uid : null;
    const { period, hour, campaign, afiliado } = useSelector(state => state.campaignsReducer.chart)
    const linkChart = useSelector(state => state.linksReducer.chart.period)
    
    const [isLoading, setLoading] = React.useState(true)
    const source = 'all'

    const [queryPeriod, setQueryPeriod] = React.useState({
        campaign_id: campaign_id,
        source: source,
        period: '7d',
        start_date: '',
        end_date: ''
    })

    const [queryHourly, setQueryHourly] = React.useState({
        campaign_id: campaign_id,
        source: source,
        period_hour: '24h',
        start_date: '',
        end_date: ''
    })

    const [queryLinkPeriod, setQueryLinkPeriod] = React.useState({
        campaign_id: campaign_id,
        source: source,
        period: '7d',
        start_date: '',
        end_date: ''
    })

    React.useEffect(() => {
        return () => {
            dispatch(change('clear'))
        }
    },[])

    React.useEffect(() => {
        !isLoading && dispatch(changeLoading({ open: true }));
        
        _period()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryPeriod])

    React.useEffect(() => {
        !isLoading && dispatch(changeLoading({ open: true }));
        
        _periodLink()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryLinkPeriod])

    React.useEffect(() => {
        !isLoading && dispatch(changeLoading({ open: true }));
        
        _hourly()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryHourly])

    const _period = (loading = false) => {
        dispatch(chartPeriod(queryPeriod, loading)).then(() => {
            dispatch(changeLoading({ open: false }))
        })
    }

    const _periodLink = (loading = false) => {
        dispatch(chartGeneralPeriod(queryLinkPeriod, loading)).then(() => {
            dispatch(changeLoading({ open: false }))
        })
    }

    const _hourly = (loading = false) => {
        dispatch(chartHourly(queryHourly, loading)).then(() => {
            setLoading(false)
            dispatch(changeLoading({ open: false }))
        })
    }

    const handleFilterPeriod = (filter) => {
        setQueryPeriod(prev => {
            const hasChanged = Object.keys(filter).some(
                key => prev[key] !== filter[key]
            );

            if (!hasChanged) return prev;

            return {
                ...prev,
                ...filter
            };
        });
    }

    const handleFilterLinkPeriod = (filter) => {
        setQueryLinkPeriod(prev => {
            const hasChanged = Object.keys(filter).some(
                key => prev[key] !== filter[key]
            );

            if (!hasChanged) return prev;

            return {
                ...prev,
                ...filter
            };
        });
    }

    const handleFilterHourly = (filter) => {
        setQueryHourly(prev => {
            const hasChanged = Object.keys(filter).some(
                key => prev[key] !== filter[key]
            );

            if (!hasChanged) return prev;

            return {
                ...prev,
                ...filter
            };
        });
    }

    return (
        <>
            <div className="app-bar">
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                            <MdKeyboardBackspace />
                        </IconButton>
                        <Typography variant="h6" className="line-clamp-1">
                            {campaign?.title ? campaign?.title : 'Análise'}
                        </Typography>
                    </Toolbar>
                </AppBar>

                {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                    <>
                        <div className="card card-body bs-bg mt-3 mb-3">
                            <ChartPeriod
                                afiliado={afiliado}
                                items={[campaign] || []}
                                chartData={period?.period_chart || []}
                                today={period?.today}
                                keyPrefix="campaign_"
                                titleField="title"
                                title={period?.period_label}
                                onChange={handleFilterPeriod}
                                presets={['7d', '1m', '3m', 'all']}
                                legend={false}
                            />

                            <div className="d-flex justify-content-between">
                                {(period.stats) &&
                                <div className="mt-3">
                                    <div className="d-flex align-items-center mb-2" >
                                        <span className="circle-legend"/>

                                        <small className="bs-color-b fw-bold">
                                            {period.stats.unique_users ? period.stats.unique_users.toLocaleString('pt-BR', { style: 'decimal' }) : 0} Usuários
                                        </small>
                                    </div>

                                    <div className="d-flex align-items-center mb-2" >
                                        <span className="circle-legend"/>

                                        <small className="bs-color-b fw-bold">
                                            {period.stats.total_purchases ? period.stats.total_purchases.toLocaleString('pt-BR', { style: 'decimal' }) : 0} Compras
                                        </small>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>

                        <div className="card card-body bs-bg mt-3 mb-3">
                            <ChartPeriod
                                afiliado={afiliado}
                                items={linkChart?.links?.data || []}
                                chartData={linkChart?.period_chart || []}
                                today={linkChart?.today}
                                keyPrefix="link_"
                                titleField="title"
                                title={linkChart?.period_label}
                                subtitle={'Vendas por Link'}
                                onChange={handleFilterLinkPeriod}
                                presets={['7d', '1m', '3m', 'all']}
                            />
                        </div>

                        <div className="card card-body bs-bg mb-3">
                            <ChartHours
                                afiliado={afiliado}
                                items={[campaign] || []}
                                chartData={hour?.hourly_chart || []}
                                bestHour={hour?.best_hour}
                                bestWindow={hour?.best_window}
                                keyPrefix="campaign_"
                                titleField="title"
                                title={hour?.period_hour_label}
                                periodKey="period_hour"
                                defaultPeriod="24h"
                                presets={['24h', '7d', '1m', '3m', 'all']}
                                onChange={handleFilterHourly}
                                legend={false}
                            />
                        </div>
                    </>
                }
            </div>
        </>
    )
}